module.exports = __webpack_public_path__ + "6dd0fc0cbd6a0174c5de11c7cc5f5b46.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/784.png
// module id = 1698
// module chunks = 2